import { type GridColDef } from "@mui/x-data-grid";
import { useMemo } from "react";

import { TableQueryParams } from "api/common/adapters/pagination.types";
import { PaginatedResponse } from "api/common/types/response.types";
import { OrgDoc } from "api/memberPortal/orgs/orgs.types";
import ServerSidePaginatedDataGrid from "components/MUI/DataGrid/ServerSidePaginatedDataGrid";

import SerialNumberTableColumns from "./SerialNumberTable.columns";

interface SerialNumberTableProps {
  documents: PaginatedResponse<OrgDoc> | undefined;
  isLoading: boolean;
  tableParams: TableQueryParams;
  setShowEditModal: (_show: boolean) => void;
  onTableParamsChange: (_queryParams: TableQueryParams) => void;
  setDocument: (_document: OrgDoc) => void;
  setShowDeleteModal: (_show: boolean) => void;
}

const SerialNumberTable = ({
  documents,
  isLoading,
  tableParams,
  setShowEditModal,
  onTableParamsChange,
  setDocument,
  setShowDeleteModal,
}: SerialNumberTableProps) => {
  const serialNumberCols: GridColDef<OrgDoc>[] = useMemo(
    () =>
      SerialNumberTableColumns({
        setShowEditModal,
        setDocument,
        setShowDeleteModal,
      }),
    [setShowEditModal, setDocument, setShowDeleteModal],
  );
  return (
    <ServerSidePaginatedDataGrid
      data={documents}
      loading={isLoading}
      title={"CCEVS Document Serial Number"}
      getRowId={(row) => row.snid}
      columns={serialNumberCols}
      initialPaginationModel={{ page: 0, pageSize: 100 }}
      tableParams={tableParams}
      onParamsChange={onTableParamsChange}
    />
  );
};

export default SerialNumberTable;
